import { render, staticRenderFns } from "./PurchaseOrderItemDatatable.vue?vue&type=template&id=2712be22"
import script from "./PurchaseOrderItemDatatable.ts?vue&type=script&lang=ts&external"
export * from "./PurchaseOrderItemDatatable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports